<form [formGroup]="borrowerDetailsForm">
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6 form-group" [attr.automation-id]="autoIdPrefix() + 'firstName' | qaSlug">
          <label class="control-label" for="firstName"
            >First Name
            @if (borrowerDetailsForm.get('firstName').enabled) {
              <span class="color-danger">*</span>
            }
          </label>
          <input
            #focusedElement
            pInputText
            name="firstName"
            maxlength="50"
            class="txt-box form-control"
            formControlName="firstName"
            autocomplete="autocompleteOffFirstName"
            id="{{ uniqueId + '-firstname' }}"
          />
          <cmg-validator-messages [control]="borrowerDetailsForm.get('firstName')" />
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6 form-group" [attr.automation-id]="autoIdPrefix() + 'middleName' | qaSlug">
          <label class="control-label" for="middleName">Middle Name</label>
          <input pInputText name="middleName" maxlength="50" class="txt-box form-control" formControlName="middleName" />
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6 form-group" [attr.automation-id]="autoIdPrefix() + 'lastName' | qaSlug">
          <label class="control-label" for="{{ uniqueId + '-lastname' }}"
            >Last Name
            @if (borrowerDetailsForm.get('lastName').enabled) {
              <span class="color-danger">*</span>
            }
          </label>
          <input
            pInputText
            name="lastName"
            maxlength="50"
            class="txt-box form-control"
            formControlName="lastName"
            autocomplete="autocompleteOffLastName"
            id="{{ uniqueId + '-lastname' }}"
          />
          <cmg-validator-messages [control]="borrowerDetailsForm.get('lastName')" />
        </div>

        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6 form-group" [attr.automation-id]="autoIdPrefix() + 'suffix' | qaSlug">
          <label class="control-label" for="{{ uniqueId + '-suffix' }}">Suffix</label>
          <input name="suffix" pInputText class="txt-box form-control" maxlength="10" formControlName="suffix" id="{{ uniqueId + '-suffix' }}" />
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6 form-group" [attr.automation-id]="autoIdPrefix() + 'ssn' | qaSlug">
          <label class="control-label ellipsis" for="{{ uniqueId + '-ssn' }}"
            >Social Security Number (or TIN)
            @if (borrowerDetailsForm.get('ssn').enabled) {
              <span class="color-danger">*</span>
            }
          </label>
          <input
            pInputText
            class="txt-box form-control w-100"
            type="text"
            inputmode="numeric"
            cmg-ssn-mask
            autocomplete="off"
            maxlength="11"
            formControlName="ssn"
            placeholder="xxx-xx-xxxx"
            id="{{ uniqueId + '-ssn' }}"
            pInputMask="999-99-9999"
            [formControl]="borrowerDetailsForm.get('ssn')"
            data-private
          />
          <cmg-validator-messages [control]="borrowerDetailsForm.get('ssn')" />
        </div>

        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix() + 'dob' | qaSlug">
          <label class="control-label" for="{{ uniqueId + '-dob' }}">Date of Birth <span class="color-danger">*</span></label>
          <p-datepicker
            data-private
            styleClass="w-100"
            formControlName="dob"
            [minDate]="minDob"
            [maxDate]="maxDob"
            [readonlyInput]="false"
            [required]="true"
            [defaultDate]="dobDefault"
            [showIcon]="true"
            placeholder="MM/DD/YYYY"
            cmg-input-error
            errorControl="p-datepicker"
            errorEvent="onClickOutside"
            appendTo="body"
            cmg-date-mask
            id="{{ uniqueId + '-dob' }}"
            [baseZIndex]="dateTimePickerCalendarZIndex"
          />
          <cmg-validator-messages [control]="borrowerDetailsForm.get('dob')" />
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix() + 'homePhone' | qaSlug">
          <label class="control-label">Home Phone</label>
          <p-inputMask
            data-private
            class="w-100"
            mask="(999) 999-9999"
            [autoClear]="true"
            [unmask]="true"
            formControlName="homePhone"
            placeholder="(xxx) xxx-xxxx"
          />
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix() + 'mobile' | qaSlug">
          <label class="control-label">
            Mobile
            @if (borrower?.isPrimaryBorrower) {
              <i
                class="pi pi-info-circle color-primary"
                pTooltip="For disclosure purposes on all applications, Borr 1 Mobile number will copy over to Borr 1 Home Phone when no Home Phone is entered"
                tooltipPosition="top"
              ></i>
            }
          </label>
          <p-inputMask
            data-private
            class="w-100"
            mask="(999) 999-9999"
            [autoClear]="true"
            [unmask]="true"
            formControlName="mobile"
            placeholder="(xxx) xxx-xxxx"
          />
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix() + 'workPhone' | qaSlug">
          <label class="control-label">Work Phone</label>
          <p-inputMask
            data-private
            class="w-100"
            mask="(999) 999-9999"
            [autoClear]="true"
            [unmask]="true"
            formControlName="workPhone"
            placeholder="(xxx) xxx-xxxx"
          />
        </div>

        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-6 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix() + 'email' | qaSlug">
          <label class="control-label">Email</label>
          <p-inputgroup>
            <input
              data-private
              class="txt-box w-100"
              autocomplete="autocompleteOffEmail"
              placeholder="xxx@xxx.com"
              pInputText
              formControlName="email"
              id="email"
            />
            <p-inputgroup-addon>
              <p-button
                type="button"
                [disabled]="borrowerDetailsForm.get('email').disabled"
                (click)="openEmail()"
                tabindex="-1"
                icon="pi pi-envelope"
              />
            </p-inputgroup-addon>
          </p-inputgroup>
        </div>

        <div
          class="col-lg-4 col-md-6 col-sm-6 col-xs-6 form-group d-flex flex-column"
          [attr.automation-id]="autoIdPrefix() + 'okToPullCredit' | qaSlug"
        >
          <div class="row checkbox-row">
            <div class="col-lg-1">
              <p-checkbox data-private [binary]="true" formControlName="okToPullCredit" inputId="okToPullCredit" />
            </div>
            <div class="col-lg-3">
              <label class="control-label" for="unitNumber">Credit Pull Authorization </label>
            </div>
          </div>
        </div>

        <div
          class="col-lg-4 col-md-6 col-sm-6 col-xs-6 form-group d-flex flex-column"
          [attr.automation-id]="autoIdPrefix() + 'isFirstTimeHomeBuyerYes' | qaSlug"
        >
          <div class="row checkbox-row">
            <div class="col-lg-1">
              <p-checkbox data-private [binary]="true" formControlName="isFirstTimeHomeBuyer" inputId="isFirstTimeHomeBuyer" />
            </div>
            <div class="col-lg-3">
              <label class="control-label" for="unitNumber">First time homebuyer </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
